module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div>\n    <div class=\"table table-w-0-100 grid-edit-table\">\n        ")
    ;  for (var i = 0; i < widget.editor.length; i++) { 
    ; __append("\n        ")
    ;  var editor = widget.editor[i]; 
    ; __append("\n        <div>\n            <div class=\"title\">")
    ; __append(escapeFn( editor.title ))
    ; __append("</div>\n            <div>\n                <control ")
    ; __append( Html.attributes(editor) )
    ; __append(" />\n            </div>\n        </div>\n        ")
    ;  } 
    ; __append("\n    </div>\n</div>\n")
  }
  return __output.join("");

}